import { Directive, Input, OnChanges, SimpleChanges, ViewContainerRef, ComponentRef, Type, Injector } from "@angular/core";

@Directive({
  selector: "[ndcDynamicComponent]",
  standalone: true,
})
export class DynamicComponentDirective implements OnChanges {
  @Input("ndcDynamicComponent") componentType!: Type<any>;
  @Input() ndcDynamicInputs: Record<string, any> = {};
  @Input() ndcDynamicOutputs: Record<string, (value: any) => void> = {};

  private cmpRef!: ComponentRef<any>;

  constructor(
    private vcr: ViewContainerRef,
    private injector: Injector
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["componentType"]) {
      this.loadComponent();
    }

    if ((changes["ndcDynamicInputs"] || changes["ndcDynamicOutputs"]) && this.cmpRef) {
      this.updateBindings();
    }
  }

  private loadComponent() {
    this.vcr.clear();

    if (!this.componentType) return;

    this.cmpRef = this.vcr.createComponent(this.componentType, {
      injector: this.injector,
    });

    this.updateBindings();
  }

  private updateBindings() {
    const instance = this.cmpRef.instance;

    Object.entries(this.ndcDynamicInputs || {}).forEach(([key, value]) => {
      instance[key] = value;
    });

    Object.entries(this.ndcDynamicOutputs || {}).forEach(([key, handler]) => {
      const output = instance[key];
      if (output && typeof output.subscribe === "function") {
        output.subscribe(handler);
      }
    });

    this.cmpRef.changeDetectorRef.detectChanges();
  }
}
